import { currencySymbol } from "../PriceWithCurrency";

const LTDTotalView = ({ suitablePrice, defaultCurrency }) => {
  const ltdUntaxedTotal = suitablePrice.price;

  return (
    <div className="flex justify-end">
      <div className="text-right">
        <div className="space-x-3 flex items-center justify-end">
          <label>Tax (13%):</label>
          <span className="text-base font-code">
            {currencySymbol(defaultCurrency)}{" "}
            {(ltdUntaxedTotal * 0.13).toFixed(3)}
          </span>
        </div>

        <div>
          <div className="space-x-3 flex items-center justify-end">
            <label>Total:</label>
            <span className="text-base font-code">
              {currencySymbol(defaultCurrency)} {ltdUntaxedTotal.toFixed(3)}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LTDTotalView;
